var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6813 1C13.953 1 13.3626 1.57313 13.3626 2.28009C13.3626 2.45745 13.3998 2.62639 13.467 2.77997L10.7047 5.46151C10.5465 5.39629 10.3724 5.36015 10.1897 5.36015C10.007 5.36015 9.83294 5.39629 9.67473 5.46151L8.02463 3.85969C8.09182 3.70612 8.12901 3.53717 8.12901 3.35979C8.12901 2.65282 7.5386 2.07969 6.81033 2.07969C6.08205 2.07969 5.49165 2.65282 5.49165 3.35979C5.49165 3.53714 5.52884 3.70608 5.59602 3.85966L2.83366 6.54117C2.67545 6.47595 2.50141 6.43982 2.31868 6.43982C1.59041 6.43982 1 7.01295 1 7.71991C1 8.42687 1.59041 9 2.31868 9C3.04695 9 3.63736 8.42687 3.63736 7.71991C3.63736 7.54255 3.60017 7.37361 3.53298 7.22003L6.29535 4.53853C6.45356 4.60375 6.62759 4.63985 6.81033 4.63985C6.99303 4.63985 7.16706 4.60375 7.32527 4.53853L8.9754 6.14037C8.90821 6.29395 8.87103 6.46289 8.87103 6.64025C8.87103 7.34721 9.46143 7.92034 10.1897 7.92034C10.918 7.92034 11.5084 7.34721 11.5084 6.64025C11.5084 6.46289 11.4712 6.29395 11.404 6.14037L14.1663 3.45883C14.3246 3.52405 14.4986 3.56015 14.6813 3.56015C15.4096 3.56015 16 2.98702 16 2.28006C16 1.5731 15.4096 1 14.6813 1Z",
    fill: "#0056CD",
    stroke: "#0056CD",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerTracking);
export default __webpack_public_path__ + "static/media/banner-tracking.c366fc22.svg";
export { ForwardRef as ReactComponent };